export function setExcludedTags(state, { licenseId, tags }) {
  state.excludedTags = { ...state.excludedTags, [licenseId]: tags };
}

export function setExcludedPackages(state, packages) {
  state.excludedPackages = packages;
}

export function setLoading(state, loading) {
  state.loading = loading;
}

export function addExcludedTag(state, { licenseId, tag }) {
  if (!state.excludedTags[licenseId]) {
    state.excludedTags[licenseId] = [];
  }
  if (!state.excludedTags[licenseId].includes(tag)) {
    state.excludedTags = {
      ...state.excludedTags,
      [licenseId]: [...state.excludedTags[licenseId], tag],
    };
  }
}

export function removeExcludedTag(state, { licenseId, tag }) {
  if (state.excludedTags[licenseId]) {
    state.excludedTags = {
      ...state.excludedTags,
      [licenseId]: state.excludedTags[licenseId].filter((t) => t !== tag),
    };
  }
}

export function clearExcludedTags(state) {
  state.excludedTags = {};
}
